import React from "react";
import ReactDOM from "react-dom";
import { HiOutlineChevronDoubleRight } from "react-icons/hi2";
import { CSSTransition } from "react-transition-group";

type SidePanelProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  header?: React.ReactNode;
  children: React.ReactNode;
};

const TRANSITION_DURATION = 200;

const SidePanel = ({ isOpen, setIsOpen, header, children }: SidePanelProps) => {
  return ReactDOM.createPortal(
    <CSSTransition in={isOpen} timeout={TRANSITION_DURATION} classNames="sidepanel" unmountOnExit>
      <div
        className={
          "fixed right-0 top-0 z-50 h-full w-full max-w-lg transform bg-white shadow-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-3xl"
        }
        data-testid="side-panel"
      >
        <div className={"flex h-screen flex-grow flex-col overflow-hidden"}>
          <SidePanelHeader>
            <SidePanelCloseButton onClose={() => setIsOpen(false)} />
            {header}
          </SidePanelHeader>
          {children}
        </div>
      </div>
    </CSSTransition>,
    document.body,
  );
};

const SidePanelCloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <button type="button" onClick={onClose} className="p-2 pl-0 focus:outline-none">
      <span className="sr-only">Close panel</span>
      <HiOutlineChevronDoubleRight aria-hidden="true" className="size-5 text-quinary hover:text-quaternary-hover" />
    </button>
  );
};

const SidePanelHeader = ({ children }: { children: React.ReactNode }) => {
  return <div className="relative mx-7 mt-6 flex justify-between">{children}</div>;
};

export default SidePanel;
